import React from "react";
import {GlobalContext} from "../../GlobalContext";
import {Button, Col, Container, Form, FormControl, FormGroup, FormLabel, Row} from "react-bootstrap";
import {Glyph} from "../common/Glyph";

export default class AdminPickListForm extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            listNames: [],
            items: [],
            selectedList: ""
        }
    }

    componentDidMount() {
        this.loadLists();
    }

    loadLists = () => {
        this.context.apiRequest("GET", "/pickList/listNames")
            .then(d => {
                if (d && d.data) {
                    this.setState({listNames: d.data});
                }
            })
    }

    listChanged = (e) => {
        let listName = e.target.value;
        if (listName) {
            this.setState({selectedList: listName}, this.loadListItems);
        }
    }

    loadListItems = () => {
        let listName = this.state.selectedList;
        if (listName) {
            this.context.apiRequest("GET", `/pickList/${listName}`)
                .then(d => {
                    if (d && d.data) {
                        this.setState({items: d.data});
                    }
                })
        }
    }

    itemChanged = (e, i) => {
        let newItems = [...this.state.items];
        newItems[i].value = e.target.value;
        if (!newItems[i].listName) {
            newItems[i].listName = this.state.selectedList;
            let sortOrder = 0;
            for (const item of newItems) {
                // find max
                if (item.sortOrder > sortOrder) sortOrder = item.sortOrder;
            }
            // if using explicit sort order, add 1 to max.
            if (sortOrder > 0) sortOrder += 1;
        }
        this.setState({items: newItems}, () => this.saveItem(i));
    }

    saveTimer = null;

    saveItem = (i) => {
        if (this.saveTimer) window.clearTimeout(this.saveTimer);
        this.saveTimer = window.setTimeout(() => {
            this.context.apiRequest("POST", "/pickList", this.state.items[i])
                .then(d => {
                    if (d && d.data) {
                        let newItems = [...this.state.items];
                        newItems[i] = d.data;
                        this.setState({items: newItems});
                    }
                })
        }, 1000);
    }

    newItem = () => {
        let newItems = [...this.state.items];
        newItems.push({id: 0, value: ""});
        this.setState({items: newItems});
    }

    deleteItem = (i) => {
        let newItems = [...this.state.items];
        let id = newItems[i].id;
        newItems.splice(i, 1);
        if (id) {
            this.context.apiRequest("DELETE", `/pickList/${id}`)
                .then(() => {
                    this.setState({items: newItems});
                })
        } else {
            this.setState({items: newItems});
        }
    }

    newList = () => {
        let name = window.prompt("Enter the name of the new list:");
        if (name) {
            if (this.state.listNames.includes(name)) {
                window.alert("A list with that name already exists.");
            } else {
                this.setState({listNames: [...this.state.listNames, name], selectedList: name, items: [{id: 0, value: ""}]});
            }
        }
    }

    render() {
        return <Container>
            <Row>
                <Form inline>
                    <FormControl as={"select"} custom value={this.state.selectedList} onChange={this.listChanged}>
                        <option value={""} disabled>Select a list</option>
                        {
                            this.state.listNames.map(i => <option key={i} value={i}>{i}</option>)
                        }
                    </FormControl>
                    <Button className={"ml-3"} variant={"secondary"} onClick={this.newList}>New List</Button>
                </Form>
            </Row>
            {
                this.state.selectedList && <>
                    <Row className={"mb-2"}>
                        <Col sm={9} className={"text-right"}>
                            <Glyph className={"clickable"} onClick={this.newItem} name={"plus-circle"}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={9}>
                            {
                                this.state.items.map((item, i) => <Row key={i} className={"mb-1 ml-3"}>
                                    <Col className={"align-self-center"}><FormControl value={item.value} onChange={e => this.itemChanged(e, i)}/></Col>
                                    <Col sm={"auto"} className={"text-center"}><Glyph name={"x-lg"} className={"clickable"} onClick={() => this.deleteItem(i)}/></Col>
                                </Row>)
                            }
                        </Col>
                    </Row>
                </>
            }
        </Container>
    }
}